<template>
    <div class="">
        <div class="container">
            <!-- <Breadcrumb class="my-3" /> -->
            <CommonBreadcrumb class="my-3" /> 
        </div>
        <section class="banner_block text-center">
            <picture>
                <source media="(min-width: 768px)" width="3840" height="1100" type="image/webp"
                    srcset="~/assets/landing/engagement/banner.webp">
                <source media="(min-width: 768px)" width="3840" height="1100" type="image/jpeg"
                    srcset="~/assets/landing/engagement/banner.jpg">

                <source media="(max-width: 767px)" width="1534" height="2128" type="image/webp"
                    srcset="~/assets/landing/engagement/banner_mobile.webp">
                <source media="(max-width: 767px)" width="1534" height="2128" type="image/jpeg"
                    srcset="~/assets/landing/engagement/banner_mobile.webp">
                <!-- <source media="(max-width: 767px)" width="767" height="349" type="image/jpeg" srcset="~/assets/landing/engagement/banner_mobile.webp"> -->

                <img alt="Discover handcrafted designs perfect for your special moment" width="3840" height="1100"
                    type="image/jpeg" src="~/assets/landing/engagement/banner.jpg">
            </picture>
            <div class="banner_upper">
                <h1 class="mb-0 font-active-mod">ENGAGEMENT RINGS</h1>
                <p class="mb-0">the look of love</p>
                <div class="banner_btn">
                    <NuxtLink class="anker radious_four" :to="localePath({ name: 'preset-listing' })">Shop pre-designed</NuxtLink>
                    <NuxtLink class="anker radious_four" :to="localePath({ name: 'cyo-setting-list-ring' })">Create your own
                    </NuxtLink>
                </div>
            </div>
        </section>
        <div class="container_fluid">
            <div class="extra_text">
                <p class="mb-0">Your search for the perfect ring ends here! Take home your Friendly Diamonds’ 100%
                    conflict-free lab diamond engagement ring created ethically in state-of-the-art laboratories,
                    maintaining the highest ecological standards to protect the environment. From classic solitaires to
                    trendy three-stone designs, our engagement rings are manufactured with the highest precision and
                    care, keeping in mind the beauty of your precious moments.
                </p>

            </div>
        </div>

        <div class="container-md full_width">
            <LandingShopByStyleTwo />
        </div>

        <div class="container-fluid cyo_banner">
            <div class="row">
                <div class="col-lg-6 col-md-12 px-0 radius_mod_left">
                    <picture>
                        <source media="(min-width: 992px)" width="1770" height="764" type="image/webp"
                            srcset="~/assets/landing/engagement/cyo_banner.webp">
                        <source media="(min-width: 992px)" width="1770" height="764" type="image/jpeg"
                            srcset="~/assets/landing/engagement/cyo_banner.jpg">

                        <source media="(max-width: 767px)" width="767" height="330" type="image/webp"
                            srcset="~/assets/landing/engagement/cyo_banner_mobile.webp">
                        <source media="(max-width: 767px)" width="767" height="330" type="image/jpeg"
                            srcset="~/assets/landing/engagement/cyo_banner_mobile.jpg">

                        <source media="(max-width: 992px)" width="992" height="382" type="image/webp"
                            srcset="~/assets/landing/engagement/cyo_engagement_ring.webp">
                        <source media="(max-width: 992px)" width="992" height="382" type="image/jpeg"
                            srcset="~/assets/landing/engagement/cyo_engagement_ring.jpg">

                        <img alt="Create Your Own Engagement Ring" loading="lazy" width="1770" height="764"
                            type="image/jpeg" src="~/assets/landing/engagement/cyo_engagement_ring.jpg">
                    </picture>
                </div>
                <div class="col-lg-6 col-md-12 px-0 d-flex align-items-center justify-content-center cyo_block_text radius_mod_right">
                    <div class="cyo_banner_text text-center">
                        <h2 class="mb-0 font-active">Create Your Own Engagement Ring</h2>
                        <p class="mb-0"> Start with a setting or a lab diamond to bring your own design to life! </p>
                        <div class="cyo_flex my-2">
                            <NuxtLink class="anker anker_light me-2 radious_four"
                                :to="localePath({ name: 'cyo-diamond-list-ring' })">
                                Start with a diamond</NuxtLink>
                            <NuxtLink class="anker anker_light ms-2 radious_four"
                                :to="localePath({ name: 'cyo-setting-list-ring' })">
                                Start with a setting</NuxtLink>
                        </div>
                        <p class="mb-0">Looking for inspiration? Browse through our <NuxtLink
                                :to="localePath({ name: 'inspiration-landing' })">customers’ creations</NuxtLink>. </p>
                    </div>
                </div>
            </div>
        </div>

        <LandingShopByShapeTwo />
        <LandingBestSeller :type="'cyor'" />

        <div class="container-fluid cyo_banner">
            <div class="row row_mod">
                <div
                    class="col-md-12 col-lg-6 px-0 d-flex align-items-center justify-content-center cyo_block_text cyo_block_text_mod radius_mod_left">
                    <div class="woman_banner_text">
                        <h3 class="mb-0 font-active">Engagement Rings <br> For Women</h3>
                        <p class="mb-0">
                            Lab created diamond engagement rings are a symbol of eternal love. Since your proposal
                            moment is one of the most significant occasions of your life, it should be nothing short of
                            perfect.
                            <br><br>
                            At Friendly Diamonds, we craft flawless rings to light up a smile on your partner’s face!
                            With over 200 designs and 10,000+ lab diamonds to choose from, you are sure to find or
                            create a custom engagement ring of your dreams.
                        </p>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6 px-0 radius_mod_right">
                    <picture>
                        <source media="(max-width: 992px)" width="992" height="382" type="image/webp"
                            srcset="~/assets/landing/engagement/woman_ring.webp">
                        <source media="(max-width: 992px)" width="992" height="382" type="image/jpeg"
                            srcset="~/assets/landing/engagement/woman_ring.jpg">

                        <source media="(max-width: 767px)" width="767" height="330" type="image/webp"
                            srcset="~/assets/landing/engagement/women_ring_mobile.webp">
                        <source media="(max-width: 767px)" width="767" height="330" type="image/jpeg"
                            srcset="~/assets/landing/engagement/women_ring_mobile.jpg">

                        <source media="(min-width: 992px)" width="3596" height="2628" type="image/webp"
                            srcset="~/assets/landing/engagement/woman_ring.webp">
                        <source media="(min-width: 992px)" width="3596" height="2628" type="image/jpeg"
                            srcset="~/assets/landing/engagement/woman_ring.jpg">

                        <img alt="Engagement Rings For Women" loading="lazy" width="3596" height="2628"
                            type="image/jpeg" src="~/assets/landing/engagement/woman_ring.jpg">
                    </picture>
                </div>
            </div>
        </div>

        <div class="container-md full_width">
            <div class="shop_metal_block">
                <HomeShopByMetal />
            </div>
        </div>

        <div class="container-md guide_faq">
            <LandingEngagementGuide />
            <HomeTestimonialsIndia v-if="$country.is_india" />
            <HomeTestimonials v-else />
            <FaqDynamicFaq />
            <!-- <EngagementFAQ /> -->
        </div>

        <div class="container-md mt-5 pt-5" v-if="$country.trustpilot">
            <HomeTrustpilotReview />
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    import { useFetchMeta } from '@/composables/useFetchMeta';
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );


    definePageMeta({
      keepalive:true
    })
    

// useHead({
// 			title:'TEST TITILE',
// 			meta: [
// 			  { name: 'description', content: 'abcd' }
// 			],
// 		  })


		  

</script>

<style scoped>
/* added this for container padding issue */
.container-md.full_width {
    margin: 0 auto;
    max-width: 1250px;
    width: 100%;
}

.container_fluid {
    padding: 2% 3%;
    max-width: 1250px;
    margin: 0 auto;
}

.woman_banner_text p a {
    text-decoration: underline;
    color: #fff;
}

.row {
    margin-left: 0;
    margin-right: 0;
}

/* ----------- */
section.banner_block {
    position: relative;
}
.radius_mod_left {
    border-radius: 8px 0 0 8px;
    overflow: hidden;
}
.radius_mod_right {
    border-radius: 0 8px 8px 0;
    overflow: hidden;
}
a.anker {
    display: inline-block;
    font-size: 13px;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 12px 25px;
}

a.anker_light {
    color: #fff;
    border: 1px solid #fff;
}

/* ------------------ */
.extra_text {
    padding: 4% 0;
}

.extra_text p {
    color: #6a6161;
    font-size: 16px;
    text-align: center;
}

/* ------------------- */
.cyo_banner {
    max-width: 1770px;
    padding: 3% 0;
    margin: 0 auto;
    width: 100%;
}

.cyo_block_text {
    background: #bd9c8c;
}

.cyo_banner_text h3,
.cyo_banner_text h2 {
    font-size: 32px;
    color: #fff;
}

.cyo_banner_text p {
    font-size: 16px;
    color: #fff;
    padding: 3% 0;
}

.cyo_banner_text p a {
    color: #fff;
    text-decoration: underline;
}

/* ----------------- */

/* ----------------- */
.womanring_block {
    max-width: 1770px;
    padding: 3% 0;
    margin: 0 auto;
}

.woman_banner_text h3 {
    font-size: 48px;
    color: #fff;
}

.woman_banner_text p {
    font-size: 16px;
    color: #fff;
    padding-top: 5%;
}

.woman_banner_text {
    padding: 0 18%;
}

/*  -------------- */
.tbd_bg {
    background: #2a4437;
}

.cyo_flex {
    display: flex;
    align-items: center;
    justify-content: center;
}

.banner_btn {
    display: flex;
    justify-content: center;
}

.banner_btn a {
    /* min-width: 200px; */
    padding: 7px 16px;
    margin-right: 3%;
}

@media(max-width: 1770px) {
    .radius_mod_left {
        border-radius: 0;
    }
    .radius_mod_right {
        border-radius: 0 ;
    }
}

@media(max-width: 1250px) {

    .cyo_banner_text h3,
    .cyo_banner_text h2 {
        font-size: 24px;
    }

    .cyo_banner_text p {
        padding: 2% 0;
    }

}

@media(max-width: 1100px) {

    .cyo_banner_text h3,
    .cyo_banner_text h2 {
        font-size: 24px;
    }

    a.anker {
        padding: 8px 20px;
    }

    .woman_banner_text {
        padding: 0 9%;
    }

    .woman_banner_text p {
        font-size: 16px;
        padding-top: 2%;
    }

    .woman_banner_text h3 {
        font-size: 24px;
    }

    .woman_banner_text h3 br {
        display: none;
    }
}

@media(max-width: 1024px) {
    .banner_btn {
        display: flex;
        flex-direction: column;
    }

    .banner_btn a {
        min-width: 200px;
        margin: 2% auto;
    }
}

@media(max-width: 992px) {
    .extra_text p {
        font-size: 16px;
    }

    .extra_text p br {
        display: none;
    }

    .cyo_banner_text {
        padding: 3% 0;
    }

    .woman_banner_text {
        padding: 4%;
        text-align: center;
    }

    .woman_banner_text h3 {
        font-size: 32px;
    }
    
}

@media(max-width: 767px) {

    .row.row_mod {
        flex-direction: column-reverse;
    }

    .cyo_banner {
        width: 100%;
    }

    /* ------------------- */

    /* ------ */
    .extra_text p {
        font-size: 16px;
    }

    .extra_text {
        padding: 10% 5%;
    }

    /* -------- */
    .cyo_block_text {

        padding: 5% !important;
    }

    .cyo_banner_text h3,
    .cyo_banner_text h2 {
        font-size: 24px;
        /* color: #000; */
    }

    a.anker_light {
        /* color: #000; */
        /* border: 1px solid #000; */
        margin: 3% 0 !important;
        width: 100% !important;
    }

    /* ---------------- */
    .cyo_block_text_mod {
        background: #bd9c8c;
    }

    .woman_banner_text h3 {
        font-size: 24px;
        padding-bottom: 3%;
    }

    .woman_banner_text {
        padding: 0;
        text-align: center;
    }

    .woman_banner_text p {
        font-size: 16px;
    }

    /* ---------------- */
    .guide_faq {
        padding: 0 5%;
    }

    .cyo_flex {
        flex-wrap: wrap;
        justify-content: center;
    }
}

/* ---------------- */
.banner_upper {
    position: absolute;
    top: 50%;
    left: 70%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: max-content;
}

.banner_upper h1 {
    font-size: 70px;
    color: #b67913;
    text-transform: uppercase;
}

.banner_upper p {
    color: #000;
    font-size: 18px;
    padding: 2% 0 4% 0;
    text-transform: capitalize;
}

/* .banner_upper a {
    min-width: 200px;
    letter-spacing: 1px;
} */
@media(max-width: 1300px) {
    .banner_upper h1 {
        font-size: 48px;
    }

    .banner_upper p {
        font-size: 16px;
    }

}

@media(max-width: 992px) {

    .banner_upper h1 {
        font-size: 26px;
    }

    .banner_upper h1 br {
        display: none;
    }

    .banner_upper p {
        font-size: 16px;
        padding: 4% 2% 8% 0;
    }
}

@media(max-width: 767px) {
    .banner_upper {
        width: 100%;
        top: 73%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .banner_upper h1 {
        font-size: 30px;
    }

    .banner_upper p {
        font-size: 16px;
        padding: 4% 2% 6% 0;
    }

    .banner_btn {
        display: flex;
        flex-direction: column;
    }

    .banner_btn a {
        max-width: 200px;
        margin: 2% auto;
        letter-spacing: 1px;
    }
}
</style>